export function kepName(value = '') {
  const tr = {ı:'i',İ:'i',ş:'s',Ş:'s',ğ:'g',Ğ:'g',ü:'u',Ü:'u',ö:'o',Ö:'o',ç:'c',Ç:'c'};
  return String(value).replace(/[ıİşŞğĞüÜöÖçÇ]/g,c=>tr[c]).normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,'.').replace(/^\.+|\.+$/g,'');
}

function choices(names) {
  // Never cut a company or person name in the middle of a word.
  return [...new Set(names)].filter(name=>name.length>1 && name.length<=40);
}

export function kepSuggestions(form) {
  if (form.account_type === 'Kurumsal') {
    const words=kepName(form.company_name).split('.').filter(Boolean);
    const endings=new Set(['limited','ltd','sti','sirketi','sirket','anonim','as','sanayi','sanayii','san','ticaret','tic']);
    while (words.length) {
      if (words.length>=2 && words.slice(-2).join('.')==='a.s') { words.splice(-2); continue; }
      if (!endings.has(words[words.length-1])) break;
      words.pop();
    }
    if (!words.length) return [];
    const brand=words[0], pair=words.slice(0,2);
    return choices([brand,brand+'.kep',pair.join('.'),pair.join(''),brand+'.iletisim',brand+'.merkez',brand+'.yazisma']).slice(0,5);
  }
  const first=kepName(form.first_name),last=kepName(form.last_name);
  if (!first||!last) return [];
  return choices([first+'.'+last,first+last,first[0]+'.'+last,first+'.'+last+'.kep',first[0]+last]).slice(0,5);
}
